export const css = {
    root: 'YjYfypzE',
    titleButton: 'slFPnD2h',
    content: '_12qlct3p',
    contentTransition: '_3sB3r9nM',
    open: '_1JisnUD-',
    arrow: '_1S3QPZHq',
    ' _key': 'afcpe-theme/dojo/title-pane'
};
export default css;
